import moment from 'moment'
import { NOT_AVAILABLE } from 'utils/constants'

export const formatDate = (input: number | string) => {
  if (typeof input === 'number') {
    return input.toString()
  } else if (typeof input === 'string') {
    const parsedDate = moment(input, ['YY-MM-DDTHH:mm:ss', 'YYYY-MM-DD'])

    if (parsedDate.isValid()) {
      return parsedDate.format('MMM. YYYY')
    } else if (/^\d{4}\/\d{2}\/\d{2}$/.test(input)) {
      const date = moment(input, 'YYYY-MM-DD')

      if (date.isValid()) {
        return date.format('MMM. YYYY')
      }

      return 'N/A'
    } else if (/^\d{4}$/.test(input)) {
      return input
    }
  }

  return NOT_AVAILABLE
}

export const getTotalRevenueTooltipText = () => {
  const vertical = window.location.pathname.split('/')[2]

  switch (vertical) {
    case 'influencers':
      return 'Estimated based on platform activity from all revenue sources (YouTube, Instagram and more), using views, followers, and the type of content posted (video, short, etc.) at the time.'
    case 'ecommerce':
      return 'Calculated using the number of sold items and reviews over time from all revenue sources, combined with typical item prices to estimate both total  and yearly revenue'
    case 'freelancers':
      return 'Estimated using job history, pricing, and reviews from platforms like Upwork and Fiverr, based on available project data and known platform fees.'
    case 'short-term-rentals':
      return 'Estimated using host’s booked or blocked calendar dates, along with the number of listings, guest reviews, and nightly rates over time on platforms like Airbnb.'
    default:
      return null
  }
}
